import {MW_ERRORS, updateUamTokenData} from 'iqos-mw';

import iccService from '@/services/icc/iccService';
import mwStateService from '@/services/mw/mwStateService';
import {selectChargerCodentify, selectHolderCodentify} from '@/state/selectors/mw';
import {setConnectionError} from '@/state/slices/mwSlice';
import {dispatch, getState} from '@/state/store';

import {sanitizeErrorForRedux} from '../errorService';

const handleConnectionError = (e) => {
    const sanitizedError = sanitizeErrorForRedux(e);

    dispatch(setConnectionError(sanitizedError));
};

const validateFlowEnded = ({onSuccess, onError, isWaitHolder}) => {
    //mark flow ended if Holder not connected or not initialized (only 1 request will be sent)
    let isFlowEnded = !isWaitHolder;
    let curError;

    const validateCurrentFlowEnded = () => {
        if (!isFlowEnded) {
            isFlowEnded = true;
            return;
        }

        if (curError) {
            onError?.(curError);
        } else {
            onSuccess?.();
        }
    };

    const onSuccessHandler = () => {
        validateCurrentFlowEnded();
    };

    const onMwError = (error) => {
        curError = error;
        validateCurrentFlowEnded();
    };

    const onErrorHandler = (error) => {
        //to escape 2 token refresh on 401 status code ignore onStartAgainHandler
        validateMwError({error, onError: onMwError});
    };

    return {onSuccessHandler, onErrorHandler};
};

const validateMwError = async ({isRetry, error, isHolder, onStartAgainHandler, onError}) => {
    if (!error) {
        onError?.();
        return;
    }

    if (error.code === MW_ERRORS.ERROR_IOT_HOLDER_NOT_CONNECTED.code) {
        mwStateService.clearHolderState();

        onError?.();

        return;
    }

    if (error.code === MW_ERRORS.ERROR_IOT_401.code) {
        if (!onStartAgainHandler || isRetry) {
            onError?.(error);
            return;
        }

        try {
            mwStateService.clearUamTokenForDevice(isHolder);

            await checkAndSetupUamToken(isHolder);

            onStartAgainHandler?.();

            return;
        } catch (e) {
            //raw error will be returned;
        }
    }

    return onError?.(error);
};

const checkAndSetupUamToken = async (isHolder) => {
    const state = getState();
    const chargerCodentify = selectChargerCodentify(state);
    const holderCodentify = selectHolderCodentify(state);
    const codentify = isHolder ? holderCodentify : chargerCodentify;
    const uamTokenData = await iccService.fetchUamToken({codentify});

    updateUamTokenData({uamTokenData, isHolder});
};

export default {
    validateFlowEnded,
    handleConnectionError,
    checkAndSetupUamToken,
    validateMwError,
};
